import httpClient from '../utils/httpClient';

export const getCategories = async (params) => {
  
    const response = await httpClient.post(`/carousel/categories`, params);
    return response.data;
};
